import React, { useEffect, useRef, useState, useMemo } from 'react';
import Skeleton from '@mui/material/Skeleton';
import dynamic from 'next/dynamic';

// Dynamically import HighchartsReact (client-only)
const HighchartsReact = dynamic(() => import('highcharts-react-official'), {
  ssr: false,
  loading: () => (
    <Skeleton
      sx={{ bgcolor: 'rgba(186, 224, 218, 0.8)' }}
      animation="wave"
      variant="rectangular"
      width={'100%'}
      height={60}
    />
  ),
});

const ChartComponent = ({
  chartRef,
  formData,
  chart,
  setZoomedIn,
  zoomedIn,
  chartOpt,
  setChart,
  id,
  className,
  chartExportRef,
  activePercentile,
}) => {
  const [HighchartsLib, setHighchartsLib] = useState(null);
  const chartRefNew = useRef(null);

  useEffect(() => {
    let isMounted = true;
    const loadHighcharts = async () => {
      const Highcharts = (await import('highcharts')).default;

      await Promise.all([
        import('highcharts/modules/exporting').then((m) => m.default(Highcharts)),
        import('highcharts/modules/export-data').then((m) => m.default(Highcharts)),
        import('highcharts/modules/offline-exporting').then((m) => m.default(Highcharts)),
        import('highcharts/modules/accessibility').then((m) => m.default(Highcharts)),
      ]);

      if (isMounted) {
        setHighchartsLib(Highcharts);
      }
    };

    loadHighcharts();
    return () => {
      isMounted = false;
    };
  }, []);

  const memoizedChartOptions = useMemo(() => chartOpt, [JSON.stringify(chartOpt)]); // prevents shallow equality trap

  const handleChartCreation = (chartInstance) => {
    if (chartInstance && typeof setChart === 'function') {
      setChart(chartInstance);
    }
  };

  const shouldRenderChart = HighchartsLib && Object.keys(chartOpt).length > 0;

  return (
    <div id={id} className={`${className} ${shouldRenderChart ? 'd-block' : 'd-none'}`}>
      {shouldRenderChart && (
        <div id="chart-container-download">
          <HighchartsReact
            highcharts={HighchartsLib}
            options={memoizedChartOptions}
            callback={handleChartCreation}
            ref={chartExportRef}
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(ChartComponent);
